export default class Person {
	constructor(id, name,lastName, email, role, internalIdentifier, dni ,category, createdAt, isActive, needsPasswordReset) {
		this.id = id;
		this.name = name;
		this.lastName = lastName;
		this.email = email;
		this.role = role;
		this.internalIdentifier= internalIdentifier;
		this.dni = dni;
		this.category = category;
		this.createdAt = createdAt;
		this.isActive = isActive;
		this.needsPasswordReset = needsPasswordReset;
	}
}